module.exports = __webpack_public_path__ + "02_glasses_black.c341934a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer4/02_glasses_black.png
// module id = 8WZn
// module chunks = 0